var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.578,
    height: 64.276,
    viewBox: "0 0 130.578 64.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M-238.736,343.42l-3.249-13H-253.26l3.592,14.368Z",
    transform: "translate(271.023 -330.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M-224.829,340.516l-2.767-10.091h-11.054l2.866,11.466Z",
    transform: "translate(280.26 -330.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M-171.356,349.181l-19.2-12.2-18.775,2.355-1.748.22-1.748.219-11.034,1.384-1.743.219-1.743.219-5.218.656-1.743.217-1.743.219-9.173,1.152-3.5.439-1.743.219-5.677.712.395,26.3C-227.871,361.248-194.628,353.727-171.356,349.181Z",
    transform: "translate(269.196 -326.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M-137.411,343.5c-2.146.326-9.34,1.451-19.587,3.34q-1.229.228-2.515.468c-.818.153-1.655.312-2.505.473-23.525,4.485-59.269,12.349-88.629,23.3-.581.217-1.157.436-1.733.654s-1.159.444-1.733.668c-3.455,1.342-6.811,2.724-10.028,4.154v9.881H-164.4c9.088-6.48,31.089-24.69,30.831-36.3A8.042,8.042,0,0,0-137.411,343.5Zm-40.982,18.637a3.387,3.387,0,0,1-3.387-3.388,3.387,3.387,0,0,1,3.387-3.387A3.387,3.387,0,0,1-175,358.747,3.387,3.387,0,0,1-178.393,362.136Zm9.8-2.458a3.388,3.388,0,0,1-3.388-3.389,3.387,3.387,0,0,1,3.388-3.387,3.388,3.388,0,0,1,3.389,3.387A3.389,3.389,0,0,1-168.593,359.678Z",
    transform: "translate(264.143 -322.159)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.da0f90e75a90c27a0699932ff385eb32.svg";
export { ForwardRef as ReactComponent };